/** Pakistani mobile check shared with the API (03XXXXXXXXX, +923XXXXXXXXX, 00923XXXXXXXXX, 3XXXXXXXXX). */
export function isValidPkMobile(phone?: string | null): boolean {
  if (!phone) return false;
  let d = phone.replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  if (d.startsWith('0')) d = '92' + d.slice(1);
  else if (d.length === 10) d = '92' + d;
  return /^923\d{9}$/.test(d);
}

/**
 * Optional phone number on Register (POS-I182): every Pakistani mobile above, or any other
 * international number of 7 to 15 digits with an optional leading +. Spaces, dashes and brackets
 * are ignored; letters are refused. Empty is allowed. Same rule as isValidPhone in the API
 * (backend/src/common/validators/phone.validator.ts).
 */
export function isValidPhoneNumber(phone?: string | null): boolean {
  if (phone == null || phone === '') return true;
  if (!/^\+?[\d\s\-()]+$/.test(phone)) return false;
  if (isValidPkMobile(phone)) return true;
  return /^\+?\d{7,15}$/.test(phone.replace(/[\s\-()]/g, ''));
}
